import React from "react";
import { useTranslation } from "react-i18next";
import { HelpCircle, Mail } from "lucide-react";

const SUPPORT_EMAIL = "support@bulkeditpro.app";

const Help = () => {
  const { t } = useTranslation();

  return (
    <div className="container-fluid py-4">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8">
          <h1 className="h4 mb-2">{t("help.title")}</h1>
          <p className="text-muted mb-4">{t("help.subtitle")}</p>
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-body">
              <h2 className="h6 mb-2">
                <Mail size={18} className="me-2 align-middle" />
                {t("help.support")}
              </h2>
              <p className="text-muted small mb-2">{t("help.supportDescLong")}</p>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="btn btn-outline-primary btn-sm">
                {t("help.contactSupport")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
